import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e6ca3eda&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=e6ca3eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ca3eda",
  null
  
)

export default component.exports